import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function SimplyGold() {
  return (
    <section
      className="relative bg-[var(--bg)] py-20 md:py-28 border-t border-white/5 overflow-hidden"
      data-testid="simply-gold-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="md:col-span-6"
        >
          <div className="h-eyebrow mb-6">§ In Collaboration</div>
          <h2 className="h-display text-4xl md:text-6xl leading-[0.95]">
            Simply Gold<br/>
            <span className="italic font-serif-editorial text-[var(--gold)] font-light">Productions.</span>
          </h2>
          <p className="mt-10 font-serif-editorial text-lg md:text-xl leading-relaxed text-[var(--ink)]/80 max-w-lg">
            For large-scale freelance projects — brand films, multi-cam events, feature-scale campaigns — the studio operates in flawless creative synergy with <span className="text-[var(--gold)]">Simply Gold Productions</span>. Two disciplined teams. One uncompromising standard.
          </p>
          <a
            href="https://simplygoldproductions.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="simply-gold-link"
            className="inline-flex items-center gap-3 mt-10 border-b border-[var(--gold)]/40 hover:border-[var(--gold)] pb-2 font-sans-display uppercase tracking-[0.3em] text-[11px] text-[var(--gold)]"
          >
            Visit SimplyGoldProductions.com ↗
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.2 }}
          className="md:col-span-6"
        >
          <div className="relative clip-frame aspect-[4/5] bg-[#111]">
            <img
              src="https://images.unsplash.com/photo-1709377195538-5522ed0f9e10?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85"
              alt="Simply Gold collaboration"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-black/70 via-transparent to-transparent" />
            <div className="absolute bottom-8 left-8 right-8 border-l border-[var(--gold)] pl-6">
              <div className="numeral text-xl mb-1">✦</div>
              <div className="font-serif-editorial italic text-white text-2xl leading-tight">
                &ldquo;Two studios. One frequency.&rdquo;
              </div>
              <div className="h-eyebrow mt-3 text-[var(--ink-muted)]">Est. Partnership</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
